<div class="status-bar-container">

    <div fxLayout="row" fxLayoutGap="5px">

        <div fxFlex>
            <div (click)="onBackButtonClicked()" class="round-button-prev" *ngIf="showBackButton">
            </div>
        </div>

        <!-- Online Status -->
        <div fxFlex="initial">
            <!-- Socket Status: {{ socketInfo | json }} --> 

            <i class="material-icons" style="color:#1DE9B6; font-size: 25px;" *ngIf="!offline">
            wifi
            </i>

            <i class="material-icons" style="color:#FF5722; font-size: 25px;" *ngIf="offline">
            wifi_off
            </i>        
        </div> 

        <!-- Socket Status Icon -->
        <div fxFlex="initial">
            <!-- Socket Status: {{ socketInfo | json }} --> 

            <i class="material-icons" style="color:#1DE9B6; font-size: 25px;" *ngIf="socketInfo.readyState == 1">
            cloud_done
            </i>

            <i class="material-icons" style="color:#FF5722; font-size: 25px;" *ngIf="socketInfo.readyState != 1">
            cloud_off
            </i>        
        </div> 
    </div>

</div>
